export enum UserRole {
    SUPER_ADMIN = 'SUPER_ADMIN',
    CHURCH_ADMIN = 'CHURCH_ADMIN',
    EDITOR = 'EDITOR',
    USER = 'USER',
}

export enum CloudProvider {
    NONE = 'NONE',
    SHAREPOINT = 'SHAREPOINT',
    GOOGLE_DRIVE = 'GOOGLE_DRIVE',
}

export enum MediaType {
    VIDEO = 'VIDEO',
    IMAGE = 'IMAGE',
    AUDIO = 'AUDIO',
    PDF = 'PDF',
    YOUTUBE = 'YOUTUBE',
    LOCAL = 'LOCAL',
    CLOUD = 'CLOUD',
    FILE = 'FILE',
    URL = 'URL',
    SPOTIFY = 'SPOTIFY',
}

export interface Church {
    id: string;
    name: string;
    address?: string;
    adminIds?: string[]; // Array of user IDs of church admins
}

export interface User {
    id: string;
    name: string;
    email: string;
    role: UserRole;
    churchId?: string; // Optional for Super Admin, required for others
    // Preferences persisted per user
    language?: 'en' | 'de';
    theme?: 'light' | 'dark';
}

export interface MediaItem {
    id: string;
    type: MediaType;
    title: string;
    url: string; // URL or File Path
    thumbnail?: string;
    duration?: string; // Duration in readable format (e.g., "4:13")
    selected: boolean;
    cached?: boolean; // For offline mode
    createdAt?: string;
    playlistId?: string; // ID of the playlist this video belongs to (if any)
    churchId?: string;
}

export interface BaseFolder {
    id: string;
    name: string;
    path?: string;
    title: string; // Display title for sidebar
}

export interface ChurchSettings {
    isFileIndexingEnabled: boolean;
    id: string;
    churchId: string;
    name?: string;
    cloudProvider: CloudProvider;
    cloudConnected: boolean;
    isWorshipEnabled: boolean;
    isMaterialEnabled: boolean;
    isSpotifyEnabled: boolean;
    isSlidesEnabled: boolean;
    youtubePlaylists: string[];
    spotifyPlaylists: string[];
    spotifyConnected?: boolean;
    maxDevices?: number;
    baseFolder?: BaseFolder; // Legacy single base folder
    baseFolders?: BaseFolder[]; // Array of base folders for multiple cloud file views
}

export interface FileNode {
    id: string;
    churchId?: string; // Root folders need this
    name: string;
    type: 'FOLDER' | 'FILE';
    mimeType?: string;
    children?: FileNode[];
    parentId?: string;
    size?: number;
    createdAt?: string;
    updatedAt?: string;
}

export interface Playlist {
    id: string;
    churchId: string;
    title: string;
    date: string;
    worshipFirst: boolean;
    worshipItems: MediaItem[];
    materialItems: MediaItem[];
    worshipItemsCount?: number;
    materialItemsCount?: number;
    updatedAt?: string;
}

export interface YouTubePlaylist {
    id: string;
    churchId: string;
    playlistId: string; // YouTube playlist ID
    title: string;
    lastUpdated: string;
    autoUpdate: boolean;
    createdAt: string;
    refreshTime: string; // Time to refresh (HH:MM format)
    isActive: boolean;
}

export interface SpotifyPlaylist {
    id: string;
    churchId: string;
    playlistId: string; // Spotify playlist ID
    title: string;
    lastUpdated: string;
    autoUpdate: boolean;
    createdAt: string;
    refreshTime: string; // Time to refresh (HH:MM format)
    isActive: boolean;
}